module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/kateryna-tkachenko-d29ab8fde8602523f7d6325db453b256.png";